import { AuditLogTableTitle } from "../enums/global.enums";

export function auditLogTitlePipe(value: string) {
    switch (value) {
        case AuditLogTableTitle.AppUser: return "Tài khoản";
        case AuditLogTableTitle.AppRole: return "Vai trò";
        case AuditLogTableTitle.WaterUser: return "Hợp đồng nước";
        case AuditLogTableTitle.WaterInvoice: return "Hóa đơn nước";
        case AuditLogTableTitle.WaterInvoiceRow: return "Chi tiết hóa đơn nước";
        case AuditLogTableTitle.WaterIndex: return "Chỉ số nước";
        case AuditLogTableTitle.TollArea: return "Khu Vực";
        case AuditLogTableTitle.WaterMeter: return "Đồng hồ nước";
        case AuditLogTableTitle.Transaction: return "Lịch sử giao dịch";
        case AuditLogTableTitle.UnitType: return "Loại hình đơn vị";
    }
    return "";
}

export function auditLogRefFieldPipe(value: string) {
    switch (value) {
        case AuditLogTableTitle.AppUser: return "UserName";
        case AuditLogTableTitle.AppRole: return "";
        case AuditLogTableTitle.WaterUser: return "Code";
        case AuditLogTableTitle.WaterInvoice: return "Code";
        case AuditLogTableTitle.WaterInvoiceRow: return "";
        case AuditLogTableTitle.WaterIndex: return "";
        case AuditLogTableTitle.TollArea: return "Code";
        case AuditLogTableTitle.WaterMeter: return "Code";
    }
    return "";
}
